import {
  Arrow,
  Content,
  Portal,
  Provider,
  Root,
  Trigger,
} from "@radix-ui/react-tooltip";
import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

type TooltipProps = ComponentProps<typeof Root>;
type TooltipProviderProps = ComponentProps<typeof Provider>;
type TooltipTriggerProps = ComponentProps<typeof Trigger>;
type TooltipContentProps = ComponentProps<typeof Content>;

export const TooltipProvider: FC<TooltipProviderProps> = ({
  delayDuration = 0,
  ...props
}) => (
  <Provider
    data-slot="tooltip-provider"
    delayDuration={delayDuration}
    {...props}
  />
);

export const Tooltip: FC<TooltipProps> = (props) => (
  <TooltipProvider>
    <Root data-slot="tooltip" {...props} />
  </TooltipProvider>
);

export const TooltipTrigger: FC<TooltipTriggerProps> = (props) => (
  <Trigger data-slot="tooltip-trigger" {...props} />
);

export const TooltipContent: FC<TooltipContentProps> = ({
  className,
  sideOffset = 0,
  children,
  ...props
}) => (
  <Portal>
    <Content
      data-slot="tooltip-content"
      sideOffset={sideOffset}
      className={cn(
        "bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance",
        className,
      )}
      {...props}
    >
      {children}
      <Arrow className="bg-primary fill-primary z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" />
    </Content>
  </Portal>
);
